// websocketClient.js
class WebSocketClient {
    constructor(url) {
        if (!WebSocketClient.instance) {
            this.socket = new WebSocket(url);
            WebSocketClient.instance = this;
        }

        return WebSocketClient.instance;
    }

    sendMessage(message) {
        if (this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(message);
        } else {
            console.error('Websocket server status:', this.socket.readyState);
        }
    }
}

const instance = new WebSocketClient('wss://pis.tools.spreeco.de/ws');
Object.freeze(instance);

export default instance;
